__turbopack_context__.v({
  "badge": "Header-module__a-ehoW__badge",
  "badgeText": "Header-module__a-ehoW__badgeText",
  "dotBadge": "Header-module__a-ehoW__dotBadge",
  "leftGroup": "Header-module__a-ehoW__leftGroup",
  "notificationWrapper": "Header-module__a-ehoW__notificationWrapper",
  "rightGroup": "Header-module__a-ehoW__rightGroup",
  "root": "Header-module__a-ehoW__root",
  "title": "Header-module__a-ehoW__title",
});
